import styled from 'styled-components';

export const Container = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  display: flex;
  align-items: flex-end;
`;

export const Logo = styled.img`
  height: 18px;
  margin-left: 4px;
`;
